export const DISCORD_INVITE_URL = 'https://discord.gg/ymrN5kTqvD';
